import { action } from 'satcheljs';
import { EntityCommand } from '@office-start/nova-facade-types';

export const onAddinTrigger = action('onAddinTrigger', (command: EntityCommand) => ({
    command,
}));
